// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportFileContent.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action, computed } from 'mobx';
import uiState from 'logic/Izenda.UiState';
import convertToDatimeFormat from 'share/utils/Izenda.ConvertToDateTimeFormat';

export default class ImportHistoryFileContent {
  @observable isSelected: boolean = false;

  @observable id: string = null;
  @observable fileKey: string = null;
  @observable fileName: string = null;
  @observable type: string = null;
  @observable typeName: string = null;
  @observable modified: string = null;
  @observable modifiedBy: string = null;
  @observable status: Number = 0;
  @observable statusName: string = null;
  @observable errorCode: Number = 0;
  @observable errorMessage: string = null;
  @observable objectId: string = null;
  @observable objectName: string = null;
  @observable saveInto: string = null;
  @observable categoryId: string = null;
  @observable categoryName: string = null;
  @observable subCategoryId: string = null;
  @observable subCategoryName: string = null;
  @observable subCategory: string = null;

  /**
   * Constructor
   * @param {Object} content
   * @param {Boolean} isSelected
   */
  constructor(content: any, isSelected: boolean) {
    const {
      id,
      fileKey,
      fileName,
      type,
      typeName,
      modified,
      modifiedBy,
      status,
      statusName,
      errorCode,
      errorMessage,
      objectId,
      objectName,
      saveInto,
      categoryId,
      categoryName,
      subCategoryId,
      subCategoryName
    } = content;

    this.id = id;
    this.fileKey = fileKey;
    this.fileName = fileName;
    this.type = type;
    this.typeName = typeName;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
    this.status = status;
    this.statusName = statusName;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.objectId = objectId;
    this.objectName = objectName;
    this.saveInto = saveInto;
    this.categoryId = categoryId;
    this.categoryName = categoryName;
    this.subCategoryId = subCategoryId;
    this.subCategoryName = subCategoryName;

    // Remember previous status isChecked
    if (isSelected) {
      this.isSelected = true;
    }
  }

  /**
   * Update selected
   * @param {boolean} value
   */
  @action
  updateSelected(value: boolean) {
    if (typeof value === 'undefined') {
      this.isSelected = !this.isSelected;
    } else {
      this.isSelected = value;
    }
  }

  /**
   * Convert date time
   * @returns {string}
   */
  @computed
  get dateLabel(): string {
    return convertToDatimeFormat(uiState.currentUser.dateFormat, this.modified);
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ImportHistoryFileContent.js